var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddList = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.667 11.917a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h8.667zM12 5.25a.75.75 0 0 1 .75.75v1.25H14a.75.75 0 0 1 0 1.5h-1.25V10a.75.75 0 0 1-1.5 0V8.75H10a.75.75 0 0 1 0-1.5h1.25V6a.75.75 0 0 1 .75-.75zm-5.25 2a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h4.75zm3.917-4.667a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h8.667z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddList);
export default ForwardRef;